function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape_2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 0C4.9 0 4 0.899999 4 2V30C4 31.1 4.9 31.9999 6 31.9999H26C27.1 31.9999 28 31.1 28 30V7.99999L20 0H6Z",
  fill: "#F2F3F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 2C4.5 1.17614 5.17614 0.5 6 0.5H19.7929L27.5 8.20709V30C27.5 30.8238 26.8238 31.4999 26 31.4999H6C5.17614 31.4999 4.5 30.8238 4.5 30V2Z",
  stroke: "#7F8C99",
  strokeOpacity: 0.35
})), /*#__PURE__*/React.createElement("path", {
  id: "Shape_3",
  opacity: 0.5,
  d: "M22 7.99999H28L20 0V5.99999C20 7.09999 20.9 7.99999 22 7.99999Z",
  fill: "#BBC1C7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_4",
  opacity: 0.3,
  d: "M28 14L22 8H28V14Z",
  fill: "#BBC1C7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_5",
  d: "M24 26C24 26.55 23.55 27 23 27H1C0.45 27 0 26.55 0 26V16C0 15.45 0.45 15 1 15H23C23.55 15 24 15.45 24 16V26Z",
  fill: "#A5ACB5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_6",
  opacity: 0.5,
  d: "M23 27H4V28H23C23.55 28 24 27.55 24 27V26C24 26.55 23.55 27 23 27Z",
  fill: "#BBC1C7"
}));
const SvgShape = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShape, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shape.c4313afc.svg";
export { ForwardRef as ReactComponent };